import {
  MessagingMessageResponse,
  MessagingMessageResponseItem
} from '@/types/service-response'
import { ReviewedItem } from '@/types/payload'

export class SystemMessage {
  private constructor (
    readonly id: number,
    readonly message: string,
    readonly date: string,
    readonly color: string,
    readonly reviewed: boolean
  ) {}

  static createListFromResponse (data: MessagingMessageResponse, messageList: SystemMessage[]): Array<SystemMessage> {
    return data.map((item: MessagingMessageResponseItem) => {
      const foundMessage: SystemMessage | undefined = messageList.find((message: SystemMessage) => message.id === item.ID)
      return new SystemMessage(
        item.ID,
        item.Message,
        item.Datum,
        item.newColor,
        foundMessage ? foundMessage.reviewed : false
      )
    })
  }

  static createListFromData (data: Array<ReviewedItem>): Array<SystemMessage> {
    return data.map((item: any) => {
      return new SystemMessage(
        item.id,
        item.message,
        item.date,
        item.color,
        item.reviewed
      )
    })
  }
}
